"use client";

import { BsExclamationTriangle } from "react-icons/bs";
import TextComponent from "@/app/_components/TextComponent";
import { useWorkspacePermissions } from "../_hooks/useWorkspacePermissions";

/**
 * A slim banner shown across the dashboard when the ACTIVE workspace is frozen
 * (§WS3) — the owner's Premium plan lapsed, so premium features are restricted
 * and mutations are blocked until it is reactivated. Personal workspaces are
 * never frozen, so this stays hidden for them. Reads the same owner-derived
 * status the server enforces, via the shared permissions hook.
 */
export default function WorkspaceFrozenBanner() {
  const { isFrozen, isOwner } = useWorkspacePermissions();
  if (!isFrozen) return null;

  return (
    <div className="flex items-start gap-3 border-b border-amber-200 bg-amber-50 px-5 py-3 xl:px-8">
      <BsExclamationTriangle className="mt-0.5 size-5 shrink-0 text-amber-500" />
      <div className="flex-1">
        <TextComponent
          type="body"
          className="font-medium text-amber-800 xl:text-[14px]"
        >
          This workspace is paused
        </TextComponent>
        <TextComponent
          type="caption"
          className="mt-0.5 text-amber-700 xl:text-[12px]"
        >
          {isOwner
            ? "Your Premium plan expired, so premium features are restricted and changes are disabled. Reactivate your subscription to resume this workspace."
            : "The workspace owner's Premium plan expired, so premium features are restricted and changes are disabled until they reactivate it."}
        </TextComponent>
      </div>
    </div>
  );
}
